import Cookies from "js-cookie";

type CookieOptions = { expires?: number };

// Cookie helpers (cross-tab persistent)
export const setCookie = (key: string, value: string, options?: CookieOptions) => {
    if (typeof window === "undefined") return;
    try {
        if (options?.expires !== undefined) Cookies.set(key, value, { expires: options.expires });
        else Cookies.set(key, value);
    } catch (e) { }
};

// Get cookie value by key, returns undefined if not found or on error
export const getCookie = (key: string): string | undefined => {
    if (typeof window === "undefined") return undefined;
    try {
        return Cookies.get(key);
    } catch (e) {
        return undefined;
    }
};

// Remove cookie by key
export const removeCookie = (key: string) => {
    if (typeof window === "undefined") return;
    try {
        Cookies.remove(key);
    } catch (e) { }
};

// JSON helpers for cookies
export const setCookieJSON = (key: string, value: any, options?: CookieOptions) => {
    try {
        setCookie(key, JSON.stringify(value), options);
    } catch (e) { }
};

// Get cookie value as JSON, returns null if not found or on error
export const getCookieJSON = (key: string) => {
    const v = getCookie(key);
    if (!v) return null;
    try {
        return JSON.parse(v);
    } catch (e) {
        return null;
    }
};

// Session storage helpers (per-tab/session)
export const setSession = (key: string, value: string) => {
    if (typeof window === "undefined") return;
    try {
        sessionStorage.setItem(key, value);
    } catch (e) { }
};

// Get session value by key, returns null if not found or on error
export const getSession = (key: string): string | null => {
    if (typeof window === "undefined") return null;
    try {
        return sessionStorage.getItem(key);
    } catch (e) {
        return null;
    }
};

// Remove session item by key
export const removeSession = (key: string) => {
    if (typeof window === "undefined") return;
    try {
        sessionStorage.removeItem(key);
    } catch (e) { }
};

// JSON helpers for session storage
export const setSessionJSON = (key: string, value: any) => {
    try {
        setSession(key, JSON.stringify(value));
    } catch (e) { }
};

// Get session value as JSON, returns null if not found or on error
export const getSessionJSON = (key: string) => {
    const v = getSession(key);
    if (!v) return null;
    try {
        return JSON.parse(v);
    } catch (e) {
        return null;
    }
};

const storage = {
    setCookie,
    getCookie,
    removeCookie,
    setCookieJSON,
    getCookieJSON,
    setSession,
    getSession,
    removeSession,
    setSessionJSON,
    getSessionJSON,
};

export default storage;
